import { documentApi } from '../../../api/apiClient';
import { FormulierProcessDependencies } from '../dependencies';

export const submitToestemmingsverklaring = async (
  _values: any,
  file: File,
  fileName: string,
  dossierId: number,
  deps: FormulierProcessDependencies
) => {
  try {
    const response = await documentApi.documentUploadToestemmingverklaringFile(fileName, dossierId, file);

    if (response)
      deps.dispatch(s => ({
        ...s,
        isComplete: true,
      }));
    else
      deps.dispatch(s => ({
        ...s,
        isComplete: false,
      }));
  } catch (e) {
    deps.dispatch(s => ({
      ...s,
      isComplete: false,
    }));
  }
};
